import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export type ColumnModifier = Modifier<
  'span-1-and-2'
>;

type Column = PropsWithChildren<{
  modifier?: ColumnModifier;
}>;

/**
 * Column in a form. Is mainly used within Row.
 * Can contain nodes, elements and Strings as children.
 */
export function Column({ modifier, children }: Column) {
  return <div className={bem('column', modifier)}>{children}</div>;
}
